import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/organization/organizationAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import OrganizationDetailForm from "./OrganizationDetailForm";
import ConfirmationDeleteModal from "../../../../Project/pages/modal-for-project/ConfirmationDeleteModal";
import OrganizationActivatedModal from "../organization-activated-modal/OrganizationActivatedModal";
import OrganizationUsageTable from "./OrganizationUsageTable";
import OrganizationEditData from "../organization-edit-data/OrganizationEditData";
import {
  loginToOrganization,
  updateOrganizationOwner
} from "../../../_redux/organization/organizationCrud";
import OrganizationDeleteModal from "../organization-delete-modal/OrganizationDeleteModal";
import { RoleChecker } from "../../../../../RoleChecker";
import ConfirmationModal from "../../../../../../_metronic/layout/components/confirmation-modal/ConfirmationModal";

export const OrganizationDetail = ({
  match: {
    params: { id }
  },
  history
}) => {
  const dispatch = useDispatch();

  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    organization_uuid: id
  });
  const [confirmationModal, setConfirmationModal] = useState({
    activated: false,
    inactive: false,
    activationOrg: false
  });
  const [modal, setModal] = useState({
    edit: false,
    delete: false
  });

  useEffect(() => {
    dispatch(actions.fetchOrganization(id));
    dispatch(actions.fetchOrganizationFiles(queryParams));
  }, [id, dispatch]);

  const {
    actionsLoading,
    organizationForEdit = {},
    error,
    isLetter,
    donorCount,
    donationAmountSum,
    donationCount,
    programCount,
    organizationFiles
  } = useSelector(
    state => ({
      actionsLoading: state.superAdminOrganization.actionsLoading,
      organizationForEdit: state.superAdminOrganization.organizationForEdit,
      isLetter: state.superAdminOrganization.is_letter,
      error: state.superAdminOrganization.error,
      donorCount: state.superAdminOrganization.donorCount,
      donationCount: state.superAdminOrganization.donationCount,
      programCount: state.superAdminOrganization.programCount,
      donationAmountSum: state.superAdminOrganization.donationAmountSum,
    }),
    shallowEqual
  );

  const { is_activated, user = {} } = organizationForEdit;

  const cardTitle = () => {
    return (
      <div>
        <span>Data {organizationForEdit.name}</span>
        <span
          style={{ marginLeft: "10px" }}
          className={`label label-lg label-light-${
            organizationForEdit.is_activated ? "success" : "danger"
          } label-inline`}
        >
          {organizationForEdit.is_activated ? "AKTIF" : "TIDAK AKTIF"}
        </span>
      </div>
    );
  };

  function updateMpzStatus(values) {
    dispatch(
      actions.updateSimpzStatus({ ...values, organization_uuid: id })
    ).then(res => {
      dispatch(actions.fetchOrganization(id));
      dispatch(actions.fetchOrganizationFiles(queryParams));
      setConfirmationModal({
        activated: false,
        activationOrg: false,
        inactive: false
      });
      toast.success("Berhasil update MPZ!", toastOption);
    });
  }

  const updateOrganization = values => {
    updateOrganizationOwner({
      ...values,
      organization_uuid: organizationForEdit.uuid
    }).then(res => {
      toast.success(res.data.message, toastOption);
      dispatch(actions.fetchOrganization(id));
      dispatch(actions.fetchOrganizationFiles(queryParams));
      setModal(prev => ({
        ...prev,
        edit: false
      }));
    });
  };

  const loginToOrg = async () => {
    const { domain_name, email } = organizationForEdit;
    const {
      data: { token }
    } = await loginToOrganization({ domain_name, email });
    if (token) {
      window.open(`https://${domain_name}/auth/login?token=${token}`);
    }
  };

  const allowEdit = RoleChecker("Edit", "organization");
  const allowDelete = RoleChecker("Delete", "organization");

  function handleOpenConfirmationModal(key) {
    setConfirmationModal(prev => ({
      ...prev,
      [key]: true
    }));
  }

  function handleCloseConfirmationModal(key) {
    setConfirmationModal(prev => ({
      ...prev,
      [key]: false
    }));
  }

  function manualActivationUser() {
    dispatch(actions.manualActivateUser(user.uuid)).then(res => {
      toast.success(res.data.message, toastOption);
      dispatch(actions.fetchOrganization(id));
      dispatch(actions.fetchOrganizationFiles(queryParams));
      handleCloseConfirmationModal("activationOrg");
    });
  }

  return (
    <>
      <OrganizationDeleteModal
        show={modal.delete}
        organization={organizationForEdit}
        onCancel={() =>
          setModal(prev => ({
            ...prev,
            delete: false
          }))
        }
      />
      <ConfirmationModal
        type="info"
        show={confirmationModal.activationOrg}
        onHide={() => handleCloseConfirmationModal("activationOrg")}
        title="Aktivasi Lembaga"
        content="Apakah anda ingin mengaktifkan user & lembaga ini?"
        onClick={() => manualActivationUser()}
      />
      <OrganizationActivatedModal
        title={`${
          organizationForEdit.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${organizationForEdit.name}`}
        show={confirmationModal.activated}
        onHide={() =>
          setConfirmationModal(prev => ({
            ...prev,
            activated: false,
            inactive: false
          }))
        }
        onClick={updateMpzStatus}
        initialValues={{
          is_activated: true,
          end_date: organizationForEdit.end_date
        }}
      />
      <ConfirmationDeleteModal
        title={`${
          organizationForEdit.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${organizationForEdit.name}`}
        show={confirmationModal.inactive}
        onHide={() =>
          setConfirmationModal(prev => ({
            ...prev,
            activated: false,
            inactive: false
          }))
        }
        content={`Apakah anda yakin ingin ${
          organizationForEdit.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${organizationForEdit.name}?`}
        onClick={() => updateMpzStatus({ is_activated: false })}
      />
      <OrganizationEditData
        initialValues={{
          ...organizationForEdit,
          organization_classification_name:
            organizationForEdit.organization_classification &&
            organizationForEdit.organization_classification.name,
          organization_regional_name:
            organizationForEdit.organization_regional &&
            organizationForEdit.organization_regional.name,
          organization_category_name:
            organizationForEdit.organization_category &&
            organizationForEdit.organization_category.name
        }}
        show={modal.edit}
        onHide={() =>
          setModal(prev => ({
            ...prev,
            edit: false
          }))
        }
        onSubmit={updateOrganization}
      />
      <Card>
        <CardHeader title={cardTitle()}>
          <CardHeaderToolbar>
            {allowDelete && (
              <button
                className="btn btn-outline-danger mr-4"
                onClick={() => {
                  setModal(prev => ({
                    ...prev,
                    delete: true
                  }));
                }}
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
                Hapus Lembaga
              </button>
            )}
            {allowEdit && (
              <>
                {!is_activated && !user.is_active && (
                  <button
                    className="btn btn-success mr-4"
                    onClick={() => handleOpenConfirmationModal("activationOrg")}
                  >
                    Aktivasi
                  </button>
                )}
                <button className="btn btn-info mr-4" onClick={loginToOrg}>
                  Login Ke Lembaga
                </button>
                {organizationFiles instanceof Array &&
                  organizationFiles.length !== 0 && (
                    <button
                      className="btn btn-outline-info mr-4"
                      onClick={() => {
                        if (organizationForEdit.is_activated) {
                          handleOpenConfirmationModal("activated");
                          handleCloseConfirmationModal("inactive");
                        } else {
                          handleOpenConfirmationModal("inactive");
                          handleCloseConfirmationModal("activated");
                        }
                      }}
                    >
                      {organizationForEdit.is_activated
                        ? "Non Aktifkan MPZ"
                        : "Aktifkan MPZ"}
                    </button>
                  )}
                <button
                  className="btn btn-primary mr-2"
                  onClick={() => {
                    setModal(prev => ({
                      ...prev,
                      edit: true
                    }));
                  }}
                >
                  Edit Data
                </button>
              </>
            )}
            <button
              className="btn btn-secondary mx-2"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <OrganizationDetailForm data={organizationForEdit} />
      </Card>
      <Card>
        <CardHeader title="Penggunaan SIMPZ" />
        <OrganizationUsageTable
          count={{
            donorCount: donorCount,
            donationCount: donationCount,
            programCount: programCount,
            donationAmountSum: donationAmountSum,
          }}
        />
      </Card>
    </>
  );
};
